'use strict';
const angular = require('angular');
const {isUndefined} = angular;

// Used to support the persistent cache while maintaining the snapshot oriented internal API
export class CachedDataSnapshot {
  constructor(key, value, ref) {
    this.$key = key;
    this.$value = value;
    this.$ref = ref;
  }

  key() {
    return this.$key;
  }

  val() {
    return this.$value;
  }

  ref() {
    return this.$ref;
  }

  exists() {
    return this.$value !== null && !isUndefined(this.$value);
  }

  // currently a lazy implementation that only supports 1 key deep
  child(path) {
    return new CachedDataSnapshot(path, this.$value ? this.$value[path] : null, this.$ref.child(path));
  }

  forEach(callback) {
    let result;

    for (let key in this.$value) {
      if (this.$value.hasOwnProperty(key)) {
        result = callback(this.child(key));

        if (result === true) {
          return true;
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/CachedDataSnapshot.js